import { exeRequest } from '../utils/APIUtils';

export default {
  getAll: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return exeRequest(`/admin/all-users?${query}`, 'GET');
  },
  delete: async (id) => exeRequest(`/admin/all-users/${id}`, 'DELETE'),
  normalizePhones: async () => exeRequest('/admin/all-users/normalize-phones', 'POST'),
  cleanOrphans: async () => exeRequest('/admin/all-users/clean-orphans', 'POST'),
  unlinkOrphan: async (id) => exeRequest(`/admin/all-users/${id}/unlink-orphan`, 'POST'),
};
